import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import getBase from "../../../javascript/base.js";
import importscript from "../../../javascript/import-script.js";

export default obj => {
	if (obj.length) {
		importscript(getBase() + "javascript/qrcode.js", () => {
			obj.each(function () {
				const $this = $(this),
					value = $this.data("qrcode");
				QRCode.toCanvas(this, value, {
					margin: 0,
					width: 200
				});
			});
		});
	}
};